import { useEffect, useState, useRef, useMemo } from 'react';
import { Button, Col, Container, Row, Form } from 'react-bootstrap';
import { useHistory, Link } from 'react-router-dom';
import _isEmpty from 'lodash/isEmpty';
import { withStore , useStore } from 'store';
// eslint-disable-next-line no-unused-vars
import { fetchMyGiftsTables, setGiftTableSearchValues, fetchSearchMyGiftsTables , setGiftTable } from 'store/actions/giftTable';
import { decodeStorage, encodeStorage } from 'functions/storageBase64';
import { CURRENT_GIFT_TABLE, PROFILE_DATA } from 'constants/storage64';
import { useStorage64 } from 'pages/Header/Content/hooks/useStorageBase64';
import GiftsLayout from 'components/gifts-table/GiftsLayout';
import { TableList } from 'components/gifts-table/TableList';
import { scrollTop } from 'util/screen';
import DeleteTableFlux from 'pages/TableAdmin/DeleteTableFlux';
// eslint-disable-next-line no-unused-vars
import { Select, Input, DatePicker, CustomDatePicker, Card, CustomIcon, Modal, PaginationList } from 'components';
import { searchGiftTableFormatter } from 'services/giftTable/formatters';
import { useWindowSize } from 'hooks';
import { setLoginRedirect } from 'util/navigation';
import { Formik, Field} from 'formik';
import { transformForSelect } from 'util/transformHelpers';
import { fetchEventTypes } from 'store/actions/catalogs';
import { FLAT } from 'constants/transformers';
import { isThereEvenAValue } from 'util/validations';
import { columns } from './columns';
import styles from './styles.module.scss';
import { initialValues, schema } from './config';
import MyTablesMobile from './Mobile';

const MyTables = ({ dispatch, myListOfGiftsTables = {} }) => {
  const [showDeleteTableFlux, setShowDeleteTableFlux] = useState(false);
  const [dataField, setDataField] = useState('');
  const history = useHistory();
  const [, setStorageGiftTable] = useStorage64(CURRENT_GIFT_TABLE, {});
  const handleClose = () => setShowDeleteTableFlux(false);

  const handleChangeGiftTable = (giftTable) => {
    setStorageGiftTable(giftTable);
    dispatch(setGiftTable(giftTable));
    encodeStorage('GIFT_TABLE_DATA',giftTable)

    if (!_isEmpty(giftTable)) {
      history.push('/my-table');
    }
  };

  const { isMobile } = useWindowSize({ largeMobile: true })[1];

  const handleChange = (page) => {
    const pageParam = isMobile ? page.mobilePage : page.page;
    myListOfGiftsTables = dispatch(fetchSearchMyGiftsTables({ withLoader: true, withModalError: false, valuesSearch, pageParam}));
    // console.log('valuesSearch en paginacion', valuesSearch);
    window.scrollTo(0, 0);
  };

   const [isLogged] = useStorage64('session_token', '');
   const isLoggedIn = !!(isLogged && isLogged.length);

  useEffect(() => {
    scrollTop();
  }, []);

  useEffect(() => {
    myListOfGiftsTables = dispatch(fetchSearchMyGiftsTables({ withLoader: true, withModalError: false, valuesSearch}));
    // console.log('valuesSearch al inicar', valuesSearch);
  }, []);


  const formik = useRef({});
  const [state] = useStore();
  const { giftTable, catalogs } = state;
  // eslint-disable-next-line no-unused-vars
  const { giftTableSearchValues = {}, listOfGiftsTables } = giftTable;

  const [valuesSearch, setValuesSearch] = useState({});

  useEffect(() => {
    // console.log('Valores a buscar: ', valuesSearch);
    // eslint-disable-next-line no-param-reassign
    myListOfGiftsTables = dispatch(fetchSearchMyGiftsTables({ withLoader: true, withModalError: true, valuesSearch}));
    // console.log('myListOfGiftsTables en values Search', myListOfGiftsTables);
    window.scrollTo(0, 0);

  },[valuesSearch]);

  const handleSubmit = (values) => {
    // console.log('values', values);
    setValuesSearch(values);
    // console.log('myListOfGiftsTables en buscar ', myListOfGiftsTables);
  };

  // const totalRegistros = listOfGiftsTables.results.list.length;
  // console.log('totalRegistros',totalRegistros);
  /* const searchResultsLengthRender = (
    <b>
      Encontramos {listOfGiftsTables.results.list.length} registros que
      coinciden con tu búsqueda
    </b>
  ); */

  const { flatEventTypes: eventTypes = [] } = catalogs;

  const eventTypeOptions = useMemo(
    () =>
      transformForSelect(eventTypes, 'id', 'name').map((event) => ({
        ...event,
        labels: undefined,
      })),
    [eventTypes]
  );

  // eslint-disable-next-line no-unused-vars
  const showTable = (table) => {
    // eslint-disable-next-line no-prototype-builtins
    if(table.hasOwnProperty('isWap') && table.isWap){
      // eslint-disable-next-line no-undef
      window.open(`${wapLink}evento/${table.evento}`, '_blank');
      return;
    }
    // eslint-disable-next-line no-undef
    history.push(getGiftTableLink(table, false));
  };

  const hasValidSearchValues = useMemo(
    () => isThereEvenAValue(giftTableSearchValues),
    [giftTableSearchValues]
  );

  useEffect(() => {
    dispatch(fetchEventTypes(false, true, FLAT));

    if (!hasValidSearchValues) return;

    const formattedValues = searchGiftTableFormatter(giftTableSearchValues);

    // eslint-disable-next-line no-undef
    dispatch(fetchGiftsTables(formattedValues));
  }, []);

  const searchGiftTableRender = (
      <Col xs={12} className="p-1">
    <Input
        className="inputborder"
        containerClassName="p-0"
        labelClassName="pl-0 text-left"
        label="Festejado (a)"
        name="celebrate_name"
        placeholder="Nombre del festejado"
        maxLength={50}
    />
      <Input
        className="inputborder"
        containerClassName="p-0"
        labelClassName="pl-0 text-left"
        name="gifttable_id"
        label="Número de evento"
        inputMode="numeric"
        maxLength={50}
      />
      {!isMobile ? (
      <DatePicker
        className="inputborder"
        containerClassName="p-0"
        labelClassName="pl-0 text-left"
        label="Fecha del evento"
        name="gifttable_date"
      />
      ) : (<Field name="gifttable_date" component={CustomDatePicker} label='Fecha del evento' maxLength={50} />)}
      <Select
        label="Tipo de evento"
        selectContainerClassName="p-0"
        labelClassName="pl-0 text-left"
        id="type_id"
        name="type_id"
        options={eventTypeOptions}
        className="inputborder"
        style={{
          border: 'none',
          borderBottomColor: 'currentcolor',
          borderBottomStyle: 'none',
          borderBottomWidth: 'medium',
          borderBottom: '1px solid darkgray !important',
          borderRadius: '0px !important',
        }}
      />
    </Col>
  );

  // eslint-disable-next-line no-unused-vars
  const giftsTables2 = state.giftTable.myListOfGiftsTables;
  // console.log('state.giftTable.myListOfGiftsTables',state.giftTable.myListOfGiftsTables);

  return (
    <>
      <DeleteTableFlux
        show={showDeleteTableFlux}
        onClose={handleClose}
        selectedTable={dataField}
      />


    {!isMobile ? (
      <GiftsLayout>
      <Container className={styles.paddingpage}>
        {/* {myListOfGiftsTables.results.list.length > 0 && (
            <Row className="pb-4 text-center">
              <Col xs={12} className="position-relative">
                <h1 className="title">Mis mesas de regalo</h1>
                <Link className={styles.floatbutton} to="/crear-mesa">
                  <Button className="mt-2 mt-lg-0">Crea tu mesa</Button>
                </Link>
                <a
                    className="link-button center"
                    href={setLoginRedirect('my-table', true, isLoggedIn, true)}
                >
                  <Button variant="primary" className={`border-0 px-4 ${styles.mobileButton}`}>
                    Mi mesa de regalos.....
                  </Button>
                </a>
              </Col>
            </Row>
        )} */}
        <Row>
            <div className="hiddenTemplate">
              <Formik
                  innerRef={formik}
                  initialValues={{
                    ...initialValues,
                    ...giftTableSearchValues,
                  }}
                  validationSchema={schema}
                  onSubmit={handleSubmit}
              >
                {(formikProps) => (
                    <Form onSubmit={formikProps.handleSubmit}>
                      <Card title="Buscar en mis mesas">
                        <h6 className="text-center">
                          Puedes buscar en tus mesas de regalos con alguno de los siguientes datos.
                        </h6>
                        {searchGiftTableRender}
                        <Button className="mb-4 mt-4 mt-lg-3 primaryButton" block type="submit">
                          Buscar
                        </Button>
                      </Card>
                    </Form>
                )}
              </Formik>
            </div>
          <Col xs={12} lg={10}>
            <TableList
                onRowClick={handleChangeGiftTable}
                data={myListOfGiftsTables.results.list}
                columns={columns}
                setShow={setShowDeleteTableFlux}
                setDataField={setDataField}
                clickableRow
            />
            {myListOfGiftsTables.results.list.length ? (
                <PaginationList
                    list={myListOfGiftsTables}
                    onChange={handleChange}
                    onMobileChange={handleChange}
                    // totalLimit={10000}
                />
            ) : null}
          </Col>
        </Row>
      </Container>
    </GiftsLayout>
    ):
    (
     <MyTablesMobile  />    
    )
    }


    </>
  );
};

export default withStore({
  mapStateToProps: (state) => ({
    myListOfGiftsTables: state.giftTable.myListOfGiftsTables,
  }),
})(MyTables);
